const body = document.querySelector('body')
const feedbackAction = [...document.querySelectorAll('a[href="#feedback-modal"]')]
const feedbackModal = document.querySelector('#feedback-modal')
const feedbackModalOverlay = feedbackModal?.querySelector('.modal__overlay')
const feedbackClose = feedbackModal?.querySelector('.modal__close')


let isActive = false

function close() {
    isActive = false
    animateOut(feedbackModal)
	body.classList.remove('overflow-hidden')
}

function open() {
    isActive = true
    animateIn(feedbackModal)
	body.classList.add('overflow-hidden')
}

function toggle(e) {
	if (e) e.preventDefault()
	isActive ? close() : open()
}

feedbackAction.forEach((action) => {
    action.addEventListener('click', toggle)
})
feedbackModalOverlay.addEventListener('click', close)
feedbackClose.addEventListener('click', close)


// detect esc key
window.addEventListener('keydown', event => {
	const escKey = (event.key === 'Escape' || event.keyCode === 27)
	const modalOpen = feedbackModal.classList.contains('active')
	if (modalOpen && escKey) toggle()
})


// Animations
function animateIn(el) {
	el.style.display="flex"
	setTimeout(() => {
		el.classList.add('active') 
	}, 200);
}

function animateOut(el) {
	el.classList.remove('active')
	setTimeout(() => {
		el.style.display="none"
	}, 500); 
}
